// extracted by mini-css-extract-plugin
export var dropArea = "meal-planer-dropzone-module--drop-area--UsdmS";
export var dropZone = "meal-planer-dropzone-module--drop-zone--EjLvt";
export var dropZoneTxt = "meal-planer-dropzone-module--drop-zone-txt--3NbRW";
export var inDropArea = "meal-planer-dropzone-module--in-drop-area--HYyMW";
export var small = "meal-planer-dropzone-module--small--gZ+AN";